<lib-temperature-icon [temperature]="temperature()" />
